import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ColorPickerService, Hsva, Rgba } from 'ngx-color-picker';
import { rgbaToString } from '../../util/converter-util';

@Component({
  selector: 'app-color-picker',
  templateUrl: './color-picker.component.html',
  styleUrls: ['./color-picker.component.scss']
})
export class ColorPickerComponent {

  @Input() alphaChannel: boolean = false;
  @Input() disabled: boolean = false;
  @Output() colorChanged: EventEmitter<Rgba> = new EventEmitter();

  private grgba: Rgba;
  @Input()
  get rgba(): Rgba { return this.grgba; }
  set rgba(rgba: Rgba) {
    if (rgba) {
      this.grgba = rgba;
      this.color = rgbaToString(this.rgba);
    }
    else {
      this.color = 'rgba(0, 0, 0, 1)';
      this.grgba = this.stringToRgba(this.color);
    }
    this.previousColor = this.color;
  }
  color: string;
  previousColor: string;
  toggle: boolean;

  constructor(private pickerService: ColorPickerService) { }

  close(): void {
    if (this.color != this.previousColor) {
      this.colorChanged.emit(this.stringToRgba(this.color));
      this.previousColor = this.color;
    }
  }

  private stringToRgba(color: string): Rgba {
    const hsva: Hsva = this.pickerService.stringToHsva(color);
    const normalizeRgba = this.pickerService.hsvaToRgba(hsva);
    return this.pickerService.denormalizeRGBA(normalizeRgba);
  }
}
